import { IAppState } from '../../redux';
import { getIsCommercial } from '../../utils/category/getIsCommercial';
import { selectOfferCategory } from './selectOfferCategory';

export const selectIsCommercial = (state: IAppState): boolean => {
  const category = selectOfferCategory(state);

  return getIsCommercial(category ?? undefined);
};
